import {useEffect, useState} from 'react';
import {NavLink} from 'react-router';
import {fetchUserAttributes} from 'aws-amplify/auth';
import {Divider, Menu, MenuItem, useTheme} from '@aws-amplify/ui-react';
import LogoMark from "./LogoMark";

type ColorTheme = 'light' | 'dark';

export default function NavBar(props: any) {
    const {signOut} = props;
    const {tokens} = useTheme();
    const [email, setEmail] = useState<string>();
    // Initial value comes from the script in public/index.html
    const [colorTheme, setColorTheme] = useState<ColorTheme>(
        document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'
    );

    useEffect(() => {
        fetchUserAttributes()
            .then(attributes => setEmail(attributes.email))
            .catch(err => console.log('error fetching user attributes:', err));
    }, []);

    function toggleColorTheme() {
        const next = colorTheme === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        localStorage.setItem('theme', next);
        setColorTheme(next);
    }

    return <header className="app-header">
        <NavLink to="/" className="app-header__logo">
            <LogoMark/>Workbreaks
        </NavLink>
        <nav className="app-nav" aria-label="Main navigation">
            {/* NavLink sets aria-current="page" on the active link */}
            <NavLink to="/" end className="app-nav__link">Home</NavLink>
            <NavLink to="/edit" className="app-nav__link">Edit</NavLink>
        </nav>
        <Menu menuAlign="end">
            {email && <MenuItem fontWeight={tokens.fontWeights.normal} fontSize={tokens.fontSizes.small}
                                isDisabled>{email}</MenuItem>}
            {email && <Divider/>}
            <MenuItem onClick={toggleColorTheme}>{colorTheme === 'dark' ? 'Light mode' : 'Dark mode'}</MenuItem>
            <MenuItem onClick={signOut}>Sign out</MenuItem>
        </Menu>
    </header>
}
